import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { take, tap } from 'rxjs/operators';

import * as firebase from 'firebase/app';
import { AuthenticationService } from './Authentication.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    // private afAuth: AngularFireAuth,
    private authService: AuthenticationService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // return true;

    firebase.auth().onAuthStateChanged(function (user) {
      if (!user) {
        // User is Not signed in.
        return false;
        this.router.navigate(['/login']);
      } else {
        return true;
      }
    });
    return true;

  }
}
